<template>
    <div>
        <div class="flex justify-end">
          <i18n class="mb-4 mr-2"/>
        </div>
        <div class="text-center font-bold glot-text-font-size-16 glot-text-line-height-20 glot-text-color-EB" v-html="$t('CheckYourEmailConfirm')">
        </div>
        <div class="mt-2 text-center font-bold glot-text-font-size-16 glot-text-line-height-20 glot-text-color-EB"><span>{{email}}</span><span class="ml-1">{{$t('Confirm')}}</span></div>
        <div class="flex flex-col justify-center items-center">
          <img class="mt-4" src="@/assets/images/icons/verificationIcon.png"/>
          <p class="text-center glot-text-font-size-14 glot-text-line-height-20 mt-6 glot-text-color-EB" v-html="$t('SentEmailConfirmAccReg')"/>
          <p class="text-center glot-text-font-size-14 glot-text-line-height-20 glot-text-color-EB" v-html="$t('SentEmailConfirmAccReg2')">
          </p>
          <div class="text-center glot-text-font-size-12 glot-text-line-height-26 mt-6 glot-text-color-C2">
            {{$t('DonReceiveEmail')}}
          </div>
            <vs-button :disabled="timerCount !== 0 || userCreateSuccess" @click="reSend" class="glot-background-color-1D mt-2" >{{$t('Resend')}}</vs-button>
            <div v-if="timerCount !== 0 " class="text-center glot-text-font-size-12 glot-text-line-height-26 mt-2 glot-text-color-C2">
              {{$t('CanSendAfter')}} <span class="glot-text-color-1D">{{ timerCount }}</span> {{$tc('Second', timerCount)}}
            </div>

            <div v-if="userCreateSuccess">
                <p class="text-center glot-text-font-size-14 glot-text-line-height-20 mt-6 green-banana" v-html="$t('RefreshPage')"/>
            </div>
            <a @click="backToLogin" class="glot-text-color-1D glot-text-font-size-12 glot-text-line-height-16 text-center cursor-pointer flex items-center mt-4">
              <vs-icon icon="icon-chevron-left" icon-pack="feather" size="12px"/>
              {{$t('BackToLoginFullPage')}}
            </a>
            <div class="text-center glot-text-color-C2 font-light mt-6">
              {{$t('EmailSupportEmail')}}
              <div>
                <b>{{$t('GlotSupportEmail')}}</b>
              </div>
            </div>
        </div>
    </div>
</template>

<script>

import _throttle from 'lodash/throttle'
import {getErrorMessage} from '@/i18n/util'
import I18n from '@/components/I18n.vue'
const COUNT_DEFAULT = 60

export default {
  components: {
    I18n
  },
  data () {
    return {
      email: '',
      timerCount : COUNT_DEFAULT,
      userCreateSuccess: false
    }
  },
  computed: {
  },
  watch: {
    timerCount: {
      handler (value) {
        if (value > 0) {
          this.canSend = 1
          setTimeout(() => {
            this.timerCount--
          }, 1000)
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }

  },
  methods:{
    reSend () { 
      this.sendEmail(this.email, this)
    },
    backToLogin () {
      this.$router.push(`/?continue=${localStorage.getItem('continueDomain')}`)
    },
    sendEmail:_throttle(function (email, vm) {
      if (email) {
        const payload = {
          email
        }
        vm.$vs.loading({
          background: 'rgba(0, 0, 0, 0.6)'
        }) 
        vm.$store.dispatch('auth/signupWithEmail', payload)
          .then(() => { 
            vm.timerCount = 10
            vm.$vs.loading.close() 
            vm.$vs.notify({
              title: vm.$t('VerificationSentTitle'),
              color: 'success',
              fixed: true
            })
          })
          .catch(error => {
            vm.$vs.loading.close() 
            // localStorage.setItem('accessToken', response.data.jwt)
            const token = localStorage.getItem('accessToken')
            if (token) {
              vm.$store.dispatch('auth/getUserInfo', {token}).then(res => {
                if (vm.email ===  res.data.email) {
                  vm.userCreateSuccess = true
                }
              })
            } else {
              vm.timerCount = 10
              vm.$vs.loading.close()
              vm.$vs.notify({
                title: 'Error',
                text: getErrorMessage(error.messages),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
                fixed: true
              })
            }
            
          })
      } else {
        vm.$vs.notify({
          title: vm.$t('emailIsInvalid'),
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          fixed: true
        })
        vm.timerCount = 10
      } 
    }, 1000)
  },
  created () {
    this.email = localStorage.getItem('email-register')
    const token = localStorage.getItem('accessToken')
    if (token) {
      this.$store.dispatch('auth/getUserInfo', {token}).then(res => {
        if (this.email ===  res.data.email) {
          this.$router.push(`/login-success?token=${token}`)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.green-banana {
    color: #3BC76F;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
}
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
